import { render, staticRenderFns } from "./Scheduler.vue?vue&type=template&id=3b6821fc&scoped=true&"
import script from "./Scheduler.vue?vue&type=script&lang=js&"
export * from "./Scheduler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6821fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6821fc')) {
      api.createRecord('3b6821fc', component.options)
    } else {
      api.reload('3b6821fc', component.options)
    }
    module.hot.accept("./Scheduler.vue?vue&type=template&id=3b6821fc&scoped=true&", function () {
      api.rerender('3b6821fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Scheduler.vue"
export default component.exports